import { actionCreatorFactory } from 'typescript-fsa'
import { KeypadItem, KeypadItemError } from './types'

const actionCreator = actionCreatorFactory('Scanner')

export const loadedKeypadItemsComplete = actionCreator<KeypadItem[]>('LOADED_KEYPAD_ITEMS_COMPLETE')

export const loadedKeypadItemsNotFound = actionCreator<KeypadItemError>('LOADED_KEYPAD_ITEMS_NOT_FOUND')

export const cleanKeypadItems = actionCreator<any>('CLEAN_KEYPAD_ITEMS')
